import { useEffect } from 'react';

// swiping the timeline horizontally can accidentally result in swiping back in browser history
// due to OS settings.
// add `overscroll-behavior-x: contain` to the <html> element to prevent horizontal scroll going
// back in history https://stackoverflow.com/questions/50616221/prevent-page-navigation-on-horizontal-scroll
// NOTE this won't work in storybook because of the iframe. You can "open canvas in new tab" to see it work in storybook.
export const usePreventSwipeBack = () => {
	useEffect(() => {
		let initOverscrollBehaviorX = '';
		if (document.body) {
			initOverscrollBehaviorX = document.body.style.overscrollBehaviorX ?? '';
			if (document.body) {
				document.body.style.overscrollBehaviorX = 'contain';
			}
		}

		return () => {
			if (document.body) {
				document.body.style.overscrollBehaviorX = initOverscrollBehaviorX;
			}
		};
	}, []);
};
